import React from 'react'

import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { Box, DataTable } from '@enechain/ecloud-designsystem'
import { getTextAlignLightTableStyle } from '@enechain/eposition-ui'

import { MarginSimulationResultForOption2Models } from '~/pages/Simulation/models/SimulationResultModel/MarginSimulationResultForOption2Models'
import { ResultSimulationForOption2Model } from '~/pages/Simulation/models/SimulationResultModel/ResultSimulationForOption2Model'

type Props = {
  resultDetail: MarginSimulationResultForOption2Models | undefined
}

export const MarginSimulationTableForOption2: React.FC<Props> = ({
  resultDetail,
}) => {
  const { t } = useTranslation(['page', 'common', 'domain'])
  const columnHelper = createColumnHelper<ResultSimulationForOption2Model>()

  const columns = [
    columnHelper.accessor('relationNumber', {
      header: t('page:simulation.relation_number'),
      cell: (info) => <Box>{info.getValue()}</Box>,
      enableSorting: false,
      meta: {
        headerStyle: {
          borderRight: `2px solid {colors.Border.midEmphasis}`,
        },
        cellStyle: {
          borderRight: `2px solid {colors.Border.midEmphasis}`,
        },
      },
    }),
    columnHelper.accessor('allRiskAmount', {
      header: t('page:simulation.all_risk_amount'),
      cell: (info) => <Box>{info.getValue()}</Box>,
      enableSorting: false,
      meta: getTextAlignLightTableStyle(),
    }),
    columnHelper.accessor('physicalFuturesRiskAmount', {
      header: t('page:simulation.physical_futures_risk_amount'),
      cell: (info) => <Box>{info.getValue()}</Box>,
      enableSorting: false,
      meta: getTextAlignLightTableStyle(),
    }),
  ]

  const table = useReactTable({
    columns,
    data: resultDetail?.details ?? [],
    getCoreRowModel: getCoreRowModel(),
  })

  if (resultDetail === undefined) {
    return null
  }

  return (
    <DataTable
      table={table}
      emptyComponent={
        <Box width="100%" textAlign="center">
          {t('common:error.empty_data')}
        </Box>
      }
    />
  )
}
